module.exports = __webpack_public_path__ + "img/profile.e4c2ce2b.jpg";